import React from 'react';

/**
 * Component to display a loading state
 */
const LoadingState = () => {
  return (
    <div className="flex flex-col items-center justify-center py-8">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary mb-4"></div>
      <p className="text-gray-700 text-center">
        Finding the best available appointment for you...
      </p>
      <p className="text-gray-500 text-sm text-center mt-2">
        This may take a few moments as we check multiple practices in your area.
      </p>
    </div>
  );
};

export default LoadingState;
